












































import { Component, Vue, Ref } from 'vue-property-decorator';
import PaymentList from './components/paymentList.vue';
import PaymentDetail from './components/paymentDetail.vue';
import { compareObj, searchParamsConvertArray, ISearchTag } from '@/utils/other';
import SearchModal from '@/components/searchModal/searchModal.vue';
import { paymentListInstance } from '@/model/PaymentListClass';
import { CHANGE_SOLUTION_STATUS, pubsub } from '@/utils/pubsub';
import { TagsViewModule } from '@/store/modules/tagsView';

type ISearchPayment = IPayment.IRequest.ISearchPayment;
type IPaymentStatusTxt = IPayment.IPaymentStatus;
type IPaymentInfo = IPayment.IResponse.IPaymentInfo;
type ILabelInfo = ILabel.IResponse.ILabelInfo;
type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;

@Component({
  name: 'Payment',
  components: {
    PaymentList,
    PaymentDetail,
    SearchModal,
  },
})
export default class Payment extends Vue {
  @Ref() private readonly searchModalRef!: SearchModal;
  private searchByStatus: IPaymentStatusTxt | 'All' = 'Approved';
  private searchByKeyword = '';
  private searchStatusOption: Array<IPaymentStatusTxt | 'All'> = ['All', 'Rejected', 'Cancel', 'Closed', 'Request', 'Approved'];
  private paymentIdForSearch: ISearchPayment = {};
  private searchTags: ISearchTag[] = [];
  private isInitData = false;
  private paymentListInstance = paymentListInstance;
  private listSpinning = false;
  private addLoading = false;
  private detailSpinning = false;
  get listData() {
    return this.paymentListInstance.list.data;
  }
  get activeId() {
    return this.currentPayment?.id;
  }
  get isMore() {
    return this.paymentListInstance.isMore;
  }
  get currentPayment() {
    return this.paymentListInstance.list.current;
  }
  private created() {
    this.initData();
  }
  private activated() {
    this.initData();
  }
  private initData() {
    if (Object.keys(this.$route.params).length && !compareObj(this.$route.params, this.paymentIdForSearch)) {
      this.paymentIdForSearch = {...this.$route.params};
      this.searchTags = searchParamsConvertArray(this.paymentIdForSearch);
      this.refreshPayment();
      this.isInitData = true;
      TagsViewModule.ChangeView({...this.$route, params: {}});
      return;
    }
    if (!this.isInitData) {
      this.initPayments({
        status: 'Approved',
      });
      this.isInitData = true;
    }
  }
  private destroyed() {
    paymentListInstance.list.clearData();
  }
  private refreshPayment() {
    this.searchByKeyword = '';
    this.searchByStatus = 'All';
    this.initPayments(this.paymentIdForSearch);
  }
  private handleSearch() {
    this.removePaymentInfoForSearch();
    const params: ISearchPayment = {};
    if (this.searchByStatus !== 'All') {
      params.status = this.searchByStatus;
    }
    if (this.searchByKeyword) {
      params.title = this.searchByKeyword;
    }
    this.initPayments(params);
  }
  private initPayments(params?: ISearchPayment) {
    this.listSpinning = true;
    this.paymentListInstance.requestData(params).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.listSpinning = false;
    });
  }
  private removePaymentInfoForSearch() {
    this.paymentIdForSearch = {};
    this.searchTags.length = 0;
  }
  private handleCreate() {
    this.paymentListInstance.createPayment();
    this.$router.push({
      name: 'CreatePayment',
    });
  }
  private removeSearchParams(key: keyof ISearchPayment) {
    delete this.paymentIdForSearch[key];
    this.searchTags = searchParamsConvertArray(this.paymentIdForSearch);
    this.refreshPayment();
  }
  private showSearchModal() {
    this.searchModalRef.showModal();
  }
  private handleModalSearch(params: ISearchPayment) {
    this.paymentIdForSearch = params;
    this.searchTags = searchParamsConvertArray(this.paymentIdForSearch);
    this.refreshPayment();
  }
  private getMoreData() {
    this.addLoading = true;
    this.paymentListInstance
      .requestMoreData()
      .catch((err) => 'requestMorePayments err' + err)
      .finally(() => {
        this.addLoading = false;
      });
  }
  private handleItemClick(payment: IPaymentInfo) {
    this.paymentListInstance.list.changeCurrent(payment);
  }
  private refreshDetail(payment: IPaymentInfo) {
    this.detailSpinning = true;
    this.paymentListInstance
      .requestDetail({
        id: payment.id,
      })
      .catch((err) => {
        if (err !== 'CANCEL') {
          this.$message.warning(err);
        }
      })
      .finally(() => {
        this.detailSpinning = false;
      });
  }
  private editPayment(payment: IPaymentInfo) {
    this.paymentListInstance.changeEditItem(payment);
    this.$router.push({
      name: 'UpdatePayment',
    });
  }
  private deletePayment(paymentId: string) {
    this.paymentListInstance.requestDeleteById(paymentId).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
  private changeStatus(params: {
    payment: IPaymentInfo;
    status: IPayment.IPaymentStatus;
  }) {
    this.paymentListInstance.requestUpdateStatus(
      params.payment,
      params.status,
    ).then((res) => {
      this.updateQuotationsStatus(params.payment, params.status);
    });
  }
  private changeLabel(params: {
    payment: IPaymentInfo;
    labels: ILabelInfo[];
  }) {
    this.paymentListInstance.updateLabel(params.payment, params.labels);
  }
  private changeComment(params: {
    type: 'ADD' | 'CHANGE';
    payment: IPaymentInfo;
    comment: ICreateOrUpdateComment;
  }) {
    const { type, payment, comment } = params;
    this.paymentListInstance.updateComment(type, payment, comment);
  }
  private updateQuotationsStatus(payment: IPaymentInfo, status: IPayment.IPaymentStatus) {
    const changeQuotationsStatus = (paymentInfo: IPaymentInfo, quotationStatus: ISolution.ISolutionStatus) => {
      const solutionIds = paymentInfo.items.map((item) => item.quotationId);
      pubsub.publish(CHANGE_SOLUTION_STATUS, {
        solutionIds,
        status: quotationStatus,
      });
    };
    switch (status) {
      case 'Approved':
        changeQuotationsStatus(payment, 'Paid');
        break;
      case 'Rejected':
        changeQuotationsStatus(payment, 'Request');
        break;
      default:
        break;
    }
  }
}
